export default "__VITE_ASSET__f9fwek$2__"